import { render, staticRenderFns } from "./shiyong.vue?vue&type=template&id=1f2f8d62&"
import script from "./shiyong.vue?vue&type=script&lang=js&"
export * from "./shiyong.vue?vue&type=script&lang=js&"
import style0 from "./shiyong.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports